import React, { useState, useEffect } from 'react';
import { MessageCircle, Phone, X } from 'lucide-react';
import { schoolInfo, whatsappMessage } from '../data/mockData';

const FloatingButtons = () => {
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButtons(true);
      } else {
        setShowButtons(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsApp = () => {
    const url = `https://wa.me/${schoolInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(url, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:${schoolInfo.phone}`;
  };

  if (!showButtons) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col space-y-4">
      {/* WhatsApp Button - Bigger & More Visible */}
      <button
        onClick={handleWhatsApp}
        className="group relative w-16 h-16 md:w-18 md:h-18 bg-green-500 hover:bg-green-600 rounded-full shadow-2xl hover:shadow-green-500/50 flex items-center justify-center transition-all duration-300 hover:scale-110 animate-bounce"
        aria-label="WhatsApp Inquiry"
      >
        <MessageCircle className="w-8 h-8 md:w-9 md:h-9 text-white" strokeWidth={2.5} />
        
        {/* Tooltip */}
        <div className="absolute right-20 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none shadow-xl">
          WhatsApp Inquiry
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full border-8 border-transparent border-l-gray-900" />
        </div>

        {/* Pulse Animation - More Prominent */}
        <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75" />
        <span className="absolute inset-0 rounded-full bg-green-400 animate-pulse opacity-50" />
      </button>

      {/* Call Button - Bigger & More Visible (Mobile Only) */}
      <button
        onClick={handleCall}
        className="group relative w-16 h-16 md:w-18 md:h-18 bg-blue-600 hover:bg-blue-700 rounded-full shadow-2xl hover:shadow-blue-500/50 flex items-center justify-center transition-all duration-300 hover:scale-110 md:hidden"
        aria-label="Call Now"
      >
        <Phone className="w-8 h-8 text-white" strokeWidth={2.5} />
        
        {/* Tooltip */}
        <div className="absolute right-20 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none shadow-xl">
          Call Now
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full border-8 border-transparent border-l-gray-900" />
        </div>

        {/* Subtle Pulse for Call Button */}
        <span className="absolute inset-0 rounded-full bg-blue-500 animate-pulse opacity-40" />
      </button>
    </div>
  );
};

export default FloatingButtons;
